import React from 'react';
import Stage from "app/views/Stage";
import { BrowserRouter } from "react-router-dom";
import Framework from "engine/logic/Framework";
import AppContext from "app/context/AppContext";
import GoogleFontLoader from 'react-google-font-loader';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheckSquare, faCoffee } from '@fortawesome/free-solid-svg-icons'
library.add(faCheckSquare, faCoffee)



class App extends React.Component {
  static displayName = App.name;
  name ="Kiwi Admin";
  framework = new Framework();
  
  state = {

  };

  constructor() {
    super();    
    window.appComponent = this;
  }  

  getAppName() {
    return this.name;
  }

  getFramework() {
    return this.framework;
  }


  processNfcTagReading(nfcTagReading) {  
    let isValidTag = true;
    if(isValidTag) {
      this.framework.getRfidSystem().processNfcTagReading(nfcTagReading);
    }
  }    

  /*processNfcTagId(nfcTagId) {
    let isValidTag = true;
    if(isValidTag) {
      let nfcTagReading = {
        nfcTagid:nfcTagId,
      };
      this.framework.getRfidSystem().processNfcTagReading(nfcTagReading);
    }    
  }*/

  processNfcTagId(nfcTagId) {  
    //alert("going through processNfcTagId:" + nfcTagId);
    //this.doConsoleLog("going through processNfcTagId:" + nfcTagId);
    let isValidTag = true;
    if(isValidTag) {
      let nfcTagReading = {
        nfcTagId: nfcTagId,
        url: "http://www.checkinworld.com",
        type: "nfc",
      };
      this.framework.getRfidSystem().processNfcTagReading(nfcTagReading);
    }
  }     

  processQrCodeReading(qrCodeReading) {
    if(this.framework.getQrCodeSystem() !== null) {
      this.framework.getQrCodeSystem().processQrCodeReading(qrCodeReading);
    }
  }  


  doConsoleLog(message) {    
    if(window.JavascriptInterface !== null && window.JavascriptInterface !== undefined) {
      if(window.JavascriptInterface.doConsoleLog !== undefined) {
        window.JavascriptInterface.doConsoleLog("" + message);
      }      
    }  
    else {
      console.log(message);
    }      
  }  

  render() {
    return (
      <div className="App">
        <GoogleFontLoader
            fonts={[
              {
                font: 'Roboto',
                weights: [300,400,500,700,900],
              },
              {
                font: 'Roboto+Slab',
                weights: [400, 700],
              },
              {
                font: 'Material+Icons+Round'
              },
            ]}
        />

        <BrowserRouter basename="/">
          <AppContext.Provider value={this}>
            <Stage />
          </AppContext.Provider>                      
        </BrowserRouter>        
      </div>
    );
  }
};



export default App;
